"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureFlags = void 0;
/**
 * Simple feature flags — will be replaced by SchematicHQ.
 * Just flip the boolean to enable/disable a feature.
 */
exports.featureFlags = {
    /** Show manual "Generate Mockup" button on products page */
    manualMockupGenerate: true,
    /** Auto-generate mockups when a design is saved */
    mockupOnSave: true,
};
